import { useContractSignWebSocket } from '#contract-sign/hooks/use-contract-sign-websocket';

export interface ContractSignWebSocketProps {
  token: string;
  userId: string;
  onSuccess?: () => void;
  onValidationError?: () => void;
  onTimeout?: () => void;
  timeoutEnabled: boolean;
}

/**
 * Invisible WebSocket component that listens for contract signing events
 * to be used in Ember components/routes.
 */
export function ContractSignWebSocket({
  token,
  userId,
  onSuccess,
  onValidationError,
  onTimeout,
  timeoutEnabled,
}: ContractSignWebSocketProps) {
  useContractSignWebSocket({
    token,
    userId,
    onSuccess: () => {
      onSuccess?.();
    },
    onValidationError: () => {
      onValidationError?.();
    },
    onTimeout: () => {
      onTimeout?.();
    },
    timeoutEnabled,
  });

  return null; // Invisible component
}
